import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_NEW_USER,
  BULK_UPLOAD,
  UPDATE_NEW_USER,
  USER_DATA,
  DELETE_USER_BYID,
  USER_ROLE
} from "./actiontype";
import {
  onAddnewUserError,
  onAddnewUserSuccess,
  onupdateUserSuccess,
  onupdateUserError,
  onDeleteuserSuccess,
  onDeleteuserError,
  togglePageLoader,
  userListError,
  userListSuccess,
  getUserRoleSuccess,
  postuploadDataError
} from "../actions";
import { getAllUsers, getUserRoleList,postAddUser,patchUpdateUser,deleteUserById} from "../../helpers/api";
import toast from "toastr";
import { notifications } from "@mantine/notifications";

function* getUsersList({ payload: params, exports, exportname }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(getAllUsers, params, exportname);

    if (exports !== "export") {
      if (response.statusCode === 200 ||response.status=="Success" ) {
        yield put(userListSuccess(response));
        yield put(togglePageLoader(false));
         //toast.success(response.message);
      } else {
        yield put(userListError(response));
        toast.error(response.message);
        yield put(togglePageLoader(false));
      }
     } 
     else {
      yield put(togglePageLoader(false));
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* createnewuser({ payload: params, callback }) {
  try {
    let notificationColor;
    yield put(togglePageLoader(true));
    const response = yield call(postAddUser, params);
    if (response.statusCode === 201 || response === true ) {
      yield put(onAddnewUserSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.statusMessage);
      callback("ADD SUCCESS");
    } else {
      notificationColor = "red";
      yield put(onAddnewUserError(response));
      toast.error(response.statusMessage);
      yield put(togglePageLoader(false));
      callback("ADD FAILURE");
    }
  } catch (error) {
    yield put(onAddnewUserError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* updatenewUser({ payload: data, callback }) {
  try {
    let notificationColor;
    yield put(togglePageLoader(true));
    const response = yield call(patchUpdateUser, data);
    if (response.statusCode === 201 || response === true ) {
      yield put(onupdateUserSuccess(response));
      yield put(togglePageLoader(false));
      toast.success(response.statusMessage);
      notificationColor = "lime";
      callback("SUCCESS");
    } else {
      notificationColor = "red";
      yield put(onupdateUserError(response));
      toast.error(response.statusMessage);
      yield put(togglePageLoader(false));
      callback("FAILURE");
   }
  } catch (error) {
    yield put(onAddnewUserError(error));
    toast.error(error?.response ? error.response?.data?.message : error);
    yield put(togglePageLoader(false));
  }
}

function* deleteUser({ payload: userId,callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(deleteUserById, userId);
   if (response.statusCode === 200 || response === true) {
      yield put(onDeleteuserSuccess(userId));
      yield put(togglePageLoader(false));
      toast.success(response.statusMessage);
      callback("SUCCESS");
    } else {
      yield put(onDeleteuserError(response));
      toast.error(response.statusMessage);
      callback("FAILURE");
   }
  } catch (error) {
    yield put(onDeleteuserError(error));
    toast.error(error?.response ? error.response.data.message : error.message);
  } finally {
    yield put(togglePageLoader(false));
  }
}

// function* bulkupload({ payload: data, callback }) {
//   try {
//     yield put(togglePageLoader(true));
//     const response = yield call(update_bulk_upload, data);
//     if (response.statusCode === 200) {
//       yield put(postuploadDataSuccess(response));
//       yield put(togglePageLoader(false));
//       toast.success(response.message);
//       callback("SUCCESS");
//     } else {
//       yield put(postuploadDataError(response));
//       toast.error(response.message);
//       yield putglePageLoader(false);
//       callback("FAILURE");
//     }
//   } catch (error) {
//     yield put(postuploadDataError(error));
//     toast.error(error?.response ? error.response?.data?.message : error);
//     yield put(togglePageLoader(false));
//   }
// }
function* getUserRole({ payload: params }) {
  const response = yield call(getUserRoleList, params);
   yield put(getUserRoleSuccess(response));
      
}
function* userlist() {
  yield takeEvery(USER_DATA, getUsersList);
  yield takeEvery(ADD_NEW_USER, createnewuser);
  yield takeEvery(UPDATE_NEW_USER, updatenewUser);
  yield takeEvery(DELETE_USER_BYID, deleteUser);
  //yield takeEvery(BULK_UPLOAD, bulkupload);
  yield takeEvery(USER_ROLE, getUserRole);
}

export default userlist;
